import { useSearchParams } from 'next/navigation';

export function useIsNewPage(): boolean {
  const search = useSearchParams();
  return search.get('newPage') === 'true';
}
